<template>
    <footer class="footBox">
        <div class="wrapper">
            <div class="foot">
                <div class="foot_nav">
                    <router-link to="/about"   >{{isZhong?'关于我们':'ABOUT'}}</router-link>
                    <router-link to="/products"  >{{isZhong?'产品':'PRODUCTS'}}</router-link>
                    <router-link to="/news"  >{{isZhong?'新闻':'NEWS'}}</router-link>
                    <router-link to="/contact"  >{{isZhong?'联系我们':'CONTACT'}}</router-link>
                    <!-- <router-link to="/privacy"  >{{isZhong?'隐私政策':'PRIVACY POLICY'}}</router-link> -->
                    <router-link to="/sitemap"  >{{isZhong?'网站地图':'SITE MAP'}}</router-link>
                </div>
                <div class="foot_bottom">
                    {{copyRight}}
                </div>
            </div>
        </div>
        <div class="footer">
            <div class="gotop" v-show="gotop" @click="toTop">
                <img src="./images/top_def.png" />
            </div>
        </div>
    </footer>
</template>

<script>
import { getCopyright } from '../../api'

export default {
   data(){
       return{
            copyRight:'',
            isZhong:false,
             gotop: false
       }
   },
   async created(){
        const language = this.$cookies.get('language');
        let isZhong;
        if(language==="zhong"){
            isZhong = true;
        }else{
            isZhong = false;
        }
        this.isZhong = isZhong;
       const res = await getCopyright();
       this.copyRight = res.data;
       
   },
   mounted(){
       // 此处true需要加上，不加滚动事件可能绑定不成功
     window.addEventListener("scroll", this.handleScroll, true);
   },
    watch:{
        copyRight(value) {
                this.$nextTick(() => { // 在dom渲染完后,再执行动画
                    var wow = new  this.$wow.WOW({
                        live: false
                    })
                    setTimeout(()=>{
                        wow.init()
                    },500)
                })
        }
    },
    methods:{
        handleScroll() {
          let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
          scrolltop > 30 ? (this.gotop = true) : (this.gotop = false);
        },
        toTop() {
            let top = document.documentElement.scrollTop || document.body.scrollTop;
            // 实现滚动效果 
            const timeTop = setInterval(() => {
                document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
                if (top <= 0) {
                clearInterval(timeTop);
                }
            }, 10);
        }
    }
};
</script>

<style lang="scss"  scoped>
@import '../../common/css/mixin.scss';
.footBox {
   padding: 66px 0; 
   background: $themeColor;
   width: 100%;
  .wrapper {
    .foot {
      .foot_nav {
        text-align: center;
        margin-top: 18px;
        a{
            color: #fff;
            font-size: 14px;
            padding: 3px 40px;
            border-right: 1px solid #fff;
            &:last-child{
                border: none;
            }
        }
      }
      .foot_bottom {
          line-height: 36px;
          margin-top: 38px;
          color: #fff;
          text-align: center;
      }
    }
  }
}

.footer .gotop {
  text-align: center;
  position: fixed;
  right: 50px;
  bottom: 30px;
  cursor: pointer;
  background: white;
  color: #000000;
  @include compatible(transition,all 0.6s);
  &:hover{
    background: #e60012;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Footer/Footer.vue